import { API_ROOT } from '../../config/config'
import { doGet, doPost, doDownload, doPostFiles, doDelete, doPut, doPutFiles } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

const API_ROOT_VER = `${API_ROOT}/v1/accounting/asset-request`

export const getAssetBookingLists = (pageNumber = 0, pageSize = 0) => {
  // http://localhost:9014/api/v1/accounting/asset-request/reserved/schema/1/10
  const url = `${API_ROOT_VER}/reserved/schema/${pageNumber}/${pageSize}`
  return doGet(url)
}

export const searchAssetBookingLists = (request, pageNumber = 0, pageSize = 0) => {
  // http://localhost:9014/api/v1/accounting/asset-request/reserved/search/1/10
  const url = `${API_ROOT_VER}/reserved/search/${pageNumber}/${pageSize}`
  return doPost(url, request)
}
